import axios from "axios"
import * as yup from 'yup'
import { getWorkordersByFilters } from '../views/redux/store'
import GlobalVariable from "./global"
import { isUserLoggedIn } from "@utils"
import workooderTransactionIdImage from '../../src/assets/images/authorizedview.jpg'
import workooderReviewlogo from '../../src/assets/images/reviewlogo.png'
import woArchived from '../../src/assets/images/Archived.png'
import woCancelled from '../../src/assets/images/Cancelled.png'
import woSuspended from '../../src/assets/images/Suspended.png'
import WOExpired from '../../src/assets/images/Expired.png'

const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn())?.isEmployee
const baseApiUrl = GlobalVariable.BASE_API_URL
const headerText = GlobalVariable.headerText
const specialCharacterPattern = /^[^#]*$/
const specialCharacterErrorMessage = "Special Character '#' is not allowed"
const hashCharacterPattern = '#'
const postalCodeErrorMessaage = 'Postal Code / Zip Code Must be between 4 to 9'
const postalCodeMin = 4
const postalCodeMax = 9

const DocusignTitle = 'You have received an email from DocuSign. Please review the document and refresh this page once signature has been completed.'
const CreditCardpercentage = 0.04
const PreviewLoaTitle = 'Approval_Letter_Preview_Document'
const CreditCardNote = 'Please note that a 4% Convenience Fee is charged based on the transaction total.'
const authorizeContent = 'Are you sure you want to authorize this work order?'
// const PaymentInstructions = `<h5 class='text-center'>Payment instructions</h5>
// <h2 class='invoice-inst' style={{ margin: '0px' }}>Payment to LISCR by Wire Transfer: <span class="invoice-inst-parag" > USD Account, Bank: <span class="font-weight-thick">JPMorgan Chase</span>, New York, NY 10017, USA, Routing Number: 21000021, SWIFT Code: CHASUS33, Account Name: LISCR, LLC - Maritime, 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166, USA, Account Number: 826835669</span></h2>
// <h2 class='invoice-inst' style={{ paddingTop: '0px' }}><span class="font-weight-thick text-black">Wells Fargo Bank,</span><span class="invoice-inst-parag" > N.A., San Francisco, CA, USA, Routing Number: 121000248, SWIFT Code: WFBIUS6S, Account Name: LISCR, LLC - Maritime, 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166, USA, Account Number: 4128526019</span></h2>
// <h2 class='invoice-inst'>Payment to LISCR by Check/Bank Draft: <span class="invoice-inst-parag">LISCR, LLC 22980 Indian Creek Drive, Suite 200, Dulles, VA 20166; Check/Bank Draft must be in USD and drawn from a US bank</span></h2>`

const PaymentInstructions = `
 <div><h2 class='invoice-inst' style={{ margin: '0px' }}>Note: <span class="invoice-inst-parag" >Please also add the workorder number in your wire transfer notes </span></h2>
 <div style="color:red;font-size:12px;font-family:Times New Roman!important;font-weight:600;text-decoration:underline;text-align:center;word-spacing:2px">IMPORTANT: OUR DEPOSITORY ACCOUNTS HAVE MOVED TO BANK OF AMERICA AND JPMORGAN CHASE BANKS
 </div>
 <div style="color:red;font-size:10px;font-family:Times New Roman!important;font-weight:600;text-align:center;word-spacing:1px;margin-top:5px">PLEASE DO NOT REMIT PAYMENTS TO WELLS FARGO BANK. USE THE BANK ACCOUNT DETAILS BELOW TO SUBMIT YOUR PAYMENTS.
 </div>
 <div style="text-align:center;font-size:15px;font-family:Times New Roman!important;font-weight:600;color:#000;margin-top:10px;text-decoration:underline">PAYMENT INSTRUCTIONS </div>
 <div>
 <div style="margin-top:10px">
  <span style="color:#000;font-size:13px;font-family:Times New Roman!important;font-weight:700">WIRE TRANSFER:</span>
  <span style="font-size:12px;font-family:Times New Roman!important;font-weight:500;padding-left:2px;color:#000">Please remit payment to one of the following bank accounts.</span>
</div>
<div style="margin-top:10px">
  <div style="display:flex;color:red;justify-content:center;font-size:12px">
    <div style="width:50%;border-right:2px solid #000">
      <div>
        <span style="width:120px;display:inline-block">Bank Name:</span>
        <span style="width:200px;display:inline-block">Bank of America N.A.</span>
        <span style="width:120px;display:inline-block"></span>
        <span style="width:200px;display:inline-block">Mclean, VA 22102, USA</span>
      </div>
      <div style="margin-top:10px">
        <span style="width:120px;display:inline-block">Swift Code:</span>
        <span style="width:200px;display:inline-block">BOFAUS3N</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Routing #:</span>
        <span style="width:200px;display:inline-block">026009593</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account Name:</span>
        <span style="width:200px;display:inline-block">LISCR,LLC - Maritime</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account #:</span>
        <span style="width:200px;display:inline-block">435059558880</span>
      </div>
    </div>
    <div style="width:50%;margin-left:12px">
      <div>
        <span style="width:120px;display:inline-block">Bank Name:</span>
        <span style="width:200px;display:inline-block">JPMorgan Chase</span>
        <span style="width:120px;display:inline-block"></span>
        <span style="width:200px;display:inline-block">New York, NY 10017, USA</span>
      </div>
      <div style="margin-top:10px">
        <span style="width:120px;display:inline-block">Swift Code:</span>
        <span style="width:200px;display:inline-block">CHASUS33</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Routing #:</span>
        <span style="width:200px;display:inline-block">021000021</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account Name:</span>
        <span style="width:200px;display:inline-block">LISCR,LLC - Maritime</span>
      </div>
      <div>
        <span style="width:120px;display:inline-block">Account #:</span>
        <span style="width:200px;display:inline-block">826835669</span>
      </div>
    </div>
  </div>
</div>
<div style="margin-top:10px">
  <span style="color:#000;font-size:13px;font-family:Times New Roman!important;font-weight:700">Payment to LISCR by Check/Bank Draft:</span>
  <span style="font-size:12px;font-family:Times New Roman!important;font-weight:500;padding-left:2px;color:#000">LISCR,LLC 22980 Indian Creek Drive,Suite 200,Dulles,VA 20166;Check/Bank Draft must be in USD and drawn from a US bank</span>
</div>
 </div>`

const customCss = {
    'font-size': '14px',
    'font-weight': '500',
    color: '#262626',
    padding: ' 0.571rem 1rem',
    'background-color': '#fff',
    border: '1px solid #d8d6de',
    'border-radius': '0.357rem'
}
const invalidCss = {
    'border-color': '#EF3340'
}
const validCss = {
    'border-color': '#d8d6de'
}

const AcknowledgementDocusignTitle1 = 'You have received an email from DocuSign. Please review the document and refresh this page once signature has been completed.'
const preorderInvoiveTitle = 'Please save the address changes before proceeding further by clicking save button'
const productcodeTitle = 'Please save the Product code changes before proceeding further by clicking save button'
const requestByValidationMessage = 'Requested By is a required field'
const AcknowledgementDocusignTitleRenewal = 'We have sent an email from LISCR to <u>{toEmail}</u>. Please review and sign the  document and refresh this page once the signature has been completed.'
const InvoicePaymentModes = [{ value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }]
const InvoicePaymentStatus = [{ value: 1, label: 'Pending' }, { value: 2, label: 'Processed' }, { value: 3, label: 'Failed' }]
const CrewTypes = [{ value: 'Add New Crew', label: 'Add New Crew' }, { value: 'Existing Crew Member', label: 'Existing Crew Member' }]
const WOStatus = [{ value: 1, label: 'Active' }, { value: 2, label: 'Deleted' }, { value: 3, label: 'Cancelled' }, { value: 4, label: 'Expired' }, { value: 6, label: 'Suspended' }]
const errorresponse = "Something Went Wrong. Please approach technical team."
const datesList = ["st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "th", "st", "nd", "rd", "th", "th", "th", "th", "th", "th", "th", "st"]
const monthnames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const fullmonthnames = [
    { key: '01', value: 'Jan' },
    { key: '02', value: 'Feb' },
    { key: '03', value: 'Mar' },
    { key: '04', value: 'Apr' },
    { key: '05', value: 'May' },
    { key: '06', value: 'Jun' },
    { key: '07', value: 'Jul' },
    { key: '08', value: 'Aug' },
    { key: '09', value: 'Sep' },
    { key: '10', value: 'Oct' },
    { key: '11', value: 'Nov' },
    { key: '12', value: 'Dec' }
]
const paymentTypeList = [{ value: 0, label: 'Pending' }, { value: 1, label: 'WireTransfer' }, { value: 2, label: 'CreditCard' }, { value: 3, label: 'PayLater' }, { value: 4, label: 'GPay' }, { value: 5, label: 'ApplePay' }, { value: 6, label: 'Not Applicable' }]
const agentClassficationList = [{ label: 'Shipowner', value: 1 }, { label: 'Third Party', value: 2 }]
const addResponseInterceptor = async (axiosInstance) => {
    axiosInstance.interceptors.response.use((response) => {
        return response
    }, async function (error) {
        const originalRequest = error.config
        if (error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true
            const access_token = error.response.headers['x-auth-token']
            const refresh_token = error.response.headers['x-refresh-token']
            localStorage.setItem("token", access_token)
            localStorage.setItem("refresh_token", refresh_token)
            originalRequest.headers['Authorization'] = `Bearer ${access_token}`
            return axiosInstance(originalRequest)
        }
        return Promise.reject(error)
    })
}

export const DefaultConfig = () => {
    let authAxios
    let authAxiosMulti
    if (localStorage.getItem("userData")) {
        const localStorageToken = localStorage.getItem('token')
        authAxios = axios.create({
            baseURL: baseApiUrl,
            headers: { Authorization: `Bearer ${localStorageToken}`, "x-refresh-token": localStorage.getItem("refresh_token") },
            withCredentials: true
        })
        addResponseInterceptor(authAxios)
        authAxiosMulti = axios.create({
            baseURL: baseApiUrl,
            headers: {
                Authorization: `Bearer ${localStorageToken}`,
                "Content-Type": "multipart/form-data",
                "x-refresh-token": localStorage.getItem("refresh_token")
            },
            withCredentials: true

        })
        addResponseInterceptor(authAxiosMulti)
    }
    const SortingDate = (data) => {
        return data.sort((a, b) => new Date(a.billingDate) - new Date(b.billingDate))
    }
    const sorter = (sortname, sortorder, filteredData) => {
        const sortData = filteredData
        sortData.sort((a, b) => {
            if (typeof a[sortname] === "number" && typeof b[sortname] === "number") {
                if (sortorder === "asc") {
                    return parseInt(a[sortname]) > parseInt(b[sortname]) ? 1 : parseInt(a[sortname]) < parseInt(b[sortname]) ? -1 : 0
                } else {
                    return parseInt(b[sortname]) > parseInt(a[sortname]) ? 1 : parseInt(b[sortname]) < parseInt(a[sortname]) ? -1 : 0
                }
            } else if (
                typeof a[sortname] === "string" && typeof b[sortname] === "string") {
                if (sortorder === "asc") {
                    return a[sortname].toLowerCase() > b[sortname].toLowerCase() ? 1 : a[sortname].toLowerCase() < b[sortname].toLowerCase() ? -1 : 0
                } else {
                    return b[sortname].toLowerCase() > a[sortname].toLowerCase() ? 1 : b[sortname].toLowerCase() < a[sortname].toLowerCase() ? -1 : 0
                }
            } else {
                if (sortorder === "asc") {
                    return a[sortname] > b[sortname] ? 1 : a[sortname] < b[sortname] ? -1 : 0
                } else {
                    return b[sortname] > a[sortname] ? 1 : b[sortname] < a[sortname] ? -1 : 0
                }
            }
        })
        return sortData
    }
    const GetUserData = () => {
        const userData = localStorage.getItem("userData")
        if (userData) {
            const userName = JSON.parse(userData)
            return `${userName.firstName} ${userName.lastName}`
        }
        return ''
    }

    const getUserRole = () => {
        const userData = localStorage.getItem("userData")
        if (userData) {
            const parsedData = JSON.parse(userData)
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => role.rId === 1)
            }
        }
        return false
    }

    const ReplaceString = (value) => {
        if (value) {
            return new Date(value.replace(/(\d+)(st|nd|rd|th)/, '$1'))
        }
        return ''
    }

    const IsEmployeeCompanyName = () => {
        if (isEmployee) {
            return true
        } else {
            return false
        }
    }

    const DateFormat = (value) => {
        if (value) {
            const monthname = monthnames[new Date(value).getMonth()]
            const datevalue = `0${new Date(value).getDate()}`.slice(-2)
            const yearvalue = new Date(value).getFullYear()
            return `${datevalue}-${monthname}-${yearvalue}`
        } else {
            return ""
        }
    }


    function AnonymousPageStatusColor(status) {
        if (status === 'Active') {
            return '#5F8E12'
        } else {
            return 'rgb(239, 51, 64)'
        }
    }

    const vaultUrl = (fileReferenceNumber) => {
        const hostname = window.location.hostname
        let env = "" // Default to production

        if (hostname.includes("dev") || hostname.includes("localhost")) {
            env = "-dev"
        } else if (hostname.includes("stg")) {
            env = "-stg"
        } else if (hostname.includes("tst")) {
            env = "-tst"
        }
        return `https://vault${env}.liscr.com/filePreview/${fileReferenceNumber}`
    }

    const handlePreviewClick = (fileReferenceNumber, link) => {
        const url = vaultUrl(fileReferenceNumber)
        if (!link) {
            window.open(url, "_blank")
        } else {
            return url
        }

    }


    const StringtoDateMonthYearFormat = (valueDate) => {
        if (valueDate) {
            const splitString = valueDate.split("-")
            if (splitString.length === 3) {
                const datevalue = splitString[0]
                const findMonth = fullmonthnames.find(find => find.key === splitString[1])
                let monthname = ''
                if (findMonth) {
                    monthname = findMonth.value
                }
                const yearvalue = splitString[2]
                return `${datevalue}-${monthname}-${yearvalue}`
            }
        }
        return ""
    }

    const validateFilename = (file) => {
        const allowedFilenameRegex = /^[a-zA-Z0-9 _-]+$/
        const fileName = file.name
        const filenameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'))
        if (!allowedFilenameRegex.test(filenameWithoutExtension)) {
            return { valid: false, message: `Invalid filename "${fileName}". Only letters, numbers, spaces, hyphens, and underscores are allowed.` }
        }
        return { valid: true }
    }

    const filterValidFiles = (files) => {
        const allowedFilenameRegex = /^[a-zA-Z0-9 _-]+$/ // Regex to allow letters, numbers, spaces, hyphens, and underscores
        return files.filter(file => {
            const fileName = file.name
            const filenameWithoutExtension = fileName.substring(0, fileName.lastIndexOf('.'))
            return allowedFilenameRegex.test(filenameWithoutExtension)
        })
    }

    const YearMonthDateFormat = (value) => {
        if (value) {
            // const splitDateFormat = value.split("T")
            // const splitDate = splitDateFormat.length > 0 ? splitDateFormat[0] : ''
            // if (splitDate) {
            //   const splitString = splitDate.split("-")
            //   if (splitString.length === 3) {
            //     const yearvalue = splitString[0]
            //     const findMonth = fullmonthnames.find(find => find.key === splitString[1])
            //     let monthname = ''
            //     if (findMonth) {
            //       monthname = findMonth.value
            //     }
            //     const datevalue = splitString[2]
            //     return `${monthname} ${datevalue && datevalue.replace(/^0/, '')}${datesList[datevalue - 1]}, ${yearvalue}`
            //   }
            // }
            const date = new Date(value)

            // Get the day, month, and year components
            let day = date.getDate()
            const monthIndex = date.getMonth()
            const year = date.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            return formattedDate
        }
        return ""
    }
    function displayCompanyValue(company, companyList) {
        // if (companyList && company) {
        //   return companyList.length && `Company Name: ${companyList?.find((item) => item.value === company)?.label ? companyList?.find((item) => item.value === company)?.label : ""}`
        // } else {
        return ""
        // }


    }
    const DateConversion = (dateStr) => {
        if (dateStr) {
            // Create a Date object from the input string
            const date = new Date(dateStr)

            // Get the day, month, and year components
            let day = date.getDate()
            const monthIndex = date.getMonth()
            const year = date.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            return formattedDate
        }
        return ''
        // if (dateStr) {
        //   // Convert to Date object
        //   const date = new Date(dateStr)

        //   // Custom function to add ordinal suffix
        //   function addOrdinalSuffix(day) {
        //     if (day >= 11 && day <= 13) {
        //       return `${day}th`
        //     }

        //     const lastDigit = day % 10
        //     switch (lastDigit) {
        //       case 1:
        //         return `${day}st`
        //       case 2:
        //         return `${day}nd`
        //       case 3:
        //         return `${day}rd`
        //       default:
        //         return `${day}th`
        //     }
        //   }

        //   // Format date and time
        //   const formattedDate = date.toLocaleDateString("en-US", {
        //     month: "short",
        //     day: "numeric",
        //     year: "numeric"
        //   })

        //   // Extract day from the formatted date
        //   const day = formattedDate.match(/\d+/)[0]

        //   // Add ordinal suffix to the day
        //   const ordinalDay = addOrdinalSuffix(day)

        //   // Combine the formatted date, ordinal day, and formatted time
        //   const formattedDateTime = `${formattedDate.replace(/\d+/, ordinalDay)}`
        //   return formattedDateTime
        // }
        // return ''
    }

    const DateEstConversion = (dateStr) => {
        if (dateStr) {
            const date = new Date(dateStr)
            const options = {
                timeZone: "America/New_York",
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            }

            const formatter = new Intl.DateTimeFormat('en-US', options)
            const parts = formatter.formatToParts(date)
            const day = parts.find(part => part.type === 'day').value
            const month = parts.find(part => part.type === 'month').value
            const year = parts.find(part => part.type === 'year').value
            return `${day} ${month} ${year}`
        }
        return ''
    }

    const GetYearAndMonth = () => {
        const currentDate = new Date()
        const options = { month: 'long', year: 'numeric' }
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(currentDate)
        if (formattedDate) {
            return formattedDate
        } else {
            return ''
        }
    }

    const DateTimeConversion = (dateStr) => {
        if (dateStr) {
            // Create a Date object from the input string
            const d = dateStr.endsWith('Z') ? `${dateStr}` : `${dateStr}z`

            const date = new Date(d)
            const estDate = new Date(date.toLocaleString("en-US", { timeZone: "America/New_York" }))

            let day = estDate.getDate()
            const monthIndex = estDate.getMonth()
            const year = estDate.getFullYear()

            if (day < 10) {
                day = `0${day}`
            }

            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`
            const formattedTime = estDate.toLocaleTimeString("en-US", {
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            })
            const formattedDateTime = `${formattedDate} ${formattedTime}`

            return formattedDateTime
        }
        return ''
    }

    const ChatDateTimeConversion = (dateStr) => {
        if (dateStr) {
            const date = new Date(dateStr)
            const estDate = new Date(date.toLocaleString("en-US", { timeZone: "America/New_York" }))

            // Get the day, month, and year components
            let day = estDate.getDate()
            const monthIndex = estDate.getMonth()
            const year = estDate.getFullYear()
            if (day < 10) {
                day = `0${day}`
            }
            // Format the date
            const formattedDate = `${day} ${monthnames[monthIndex]} ${year}`

            const formattedTime = estDate.toLocaleTimeString("en-US", {
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
            })
            const formattedDateTime = `${formattedDate} ${formattedTime}`

            return formattedDateTime
        }
        return ''
    }

    const timerLimit = 5
    const AmountFormat = (dataArray) => {
        let x = dataArray
        x = Number.parseFloat(x).toFixed(2)
        x = x.toString()
        let afterPoint = ""
        if (x.indexOf(".") > 0) {
            afterPoint = x.substring(x.indexOf("."), x.length)
        }
        x = Math.floor(x)
        x = x.toString()
        let lastThree = x.substring(x.length - 3)
        const otherNumbers = x.substring(0, x.length - 3)
        if (otherNumbers !== "") {
            lastThree = `,${lastThree}`
        }
        const res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree + afterPoint
        if (res) {
            return `${res}`
        } else {
            return ``
        }
    }

    const selectStyles = {
        container: (provided) => ({
            ...provided,
            marginTop: 0
        }),
        valueContainer: (provided) => ({
            ...provided,
            overflow: "visible"
        }),
        placeholder: (base, state) => ({
            ...base,
            position: "absolute",
            top: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) ? '-45%' : '20%',
            transition: 'top 0.2s, font-size 0.2s',
            fontSize: (state.hasValue || state.selectProps.inputValue || state.selectProps.menuIsOpen) && 14,
            // background: "#fff",
            padding: "0 5px",
            fontWeight: 500,
            color: '#000'
        })
    }

    const DisplayStatus = (status) => {
        if (status) {
            const findStatus = WOStatus.find(find => find.value === status)
            if (findStatus) {
                return findStatus.label
            }
            return ''
        }
        return ''
    }

    const emailDurationTime = 30 * 1000

    const timer = 5

    const myEncodeURIComponent = (value) => {
        //let originalString = value
        //if (originalString.includes('~')) {
        //originalString = originalString.replace(/~/g, '%7E')
        //}
        //if (originalString.includes('!')) {
        //originalString = originalString.replace(/!/g, '%21')
        //}
        //if (originalString.includes('*')) {
        //originalString = originalString.replace(/\*/g, '%2A')
        //}
        //if (originalString.includes('(')) {
        //originalString = originalString.replace(/\(/g, '%28')
        //}
        //if (originalString.includes(')')) {
        //originalString = originalString.replace(/\)/g, '%29')
        //}
        //if (originalString.includes('-')) {
        //originalString = originalString.replace(/-/g, '%2D')
        //}
        //if (originalString.includes('_')) {
        //originalString = originalString.replace(/_/g, '%5F')
        //}
        //return encodeURIComponent(originalString)
        return encodeURIComponent(value)
    }

    const myDecodeURIComponent = (encodedValue) => {
        // let originalString = decodeURIComponent(encodedValue)
        // if (originalString.includes('%7E')) {
        //originalString = originalString.replace(/%7E/g, '~')
        //}
        //if (originalString.includes('%21')) {
        // originalString = originalString.replace(/%21/g, '!')
        //}
        //if (originalString.includes('%2A')) {
        //originalString = originalString.replace(/%2A/g, '*')
        //}
        //if (originalString.includes('%28')) {
        // originalString = originalString.replace(/%28/g, '(')
        //}
        //if (originalString.includes('%29')) {
        //originalString = originalString.replace(/%29/g, ')')
        //}
        //if (originalString.includes('%2D')) {
        //originalString = originalString.replace(/%2D/g, '-')
        //}
        //if (originalString.includes('%5F')) {
        //originalString = originalString.replace(/%5F/g, '_')
        //}
        //return originalString
        return decodeURIComponent(encodedValue)
    }
    const isWithinOneYearRange = (date) => {
        const currentDate = new Date()
        const minSelectableDate = new Date()
        minSelectableDate.setFullYear(minSelectableDate.getFullYear() - 1)
        const givenDate = new Date(date)
        return givenDate >= minSelectableDate && givenDate <= currentDate
    }
    const StepperName = "Pending Submission"

    const StampView = (status, stageVal, totalStages, type) => {
        
        if (status === 1) {
            if (totalStages === 6 || type === 'AFF') {
                if (stageVal === 6) {
                    return workooderTransactionIdImage
                } else if (stageVal === 5 || stageVal === 4) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 7) {

                if (type !== "MPA" && type !== "RPA") {
                    if (stageVal === 7) {
                        return workooderTransactionIdImage
                    } else if (stageVal === 6 || stageVal === 5) {
                        return workooderReviewlogo
                    }
                } else {
                    if (stageVal === 7) {
                        return workooderTransactionIdImage
                    } else if (stageVal === 6 || stageVal === 5 || stageVal === 4) {
                        return workooderReviewlogo
                    }
                }

            } else if (totalStages === 5) {
                if (stageVal === 5) {
                    return workooderTransactionIdImage
                } else if (stageVal === 4 || stageVal === 3) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 4) {
                if (stageVal === 4) {
                    return workooderTransactionIdImage
                } else if (stageVal === 2 || stageVal === 3) {
                    return workooderReviewlogo
                }
            } else if (totalStages === 3) {
                if (stageVal === 3) {
                    return workooderTransactionIdImage
                } else if (stageVal === 2) {
                    return workooderReviewlogo
                }
            }
        } else if (status === 2) {
            return woCancelled
        } else if (status === 3) {
            return woArchived
        } else if (status === 4) {
            return WOExpired
        } else if (status === 6) {
            return woSuspended
        }
    }

    const statusNamesForStageValues = (stageVal, totalStages, type) => {
        if (totalStages === 6 || type === 'AFF') {
            if (stageVal === 3) {
                return StepperName
            } else if (stageVal === 4) {
                return 'To Be Reviewed'
            } else if (stageVal === 5) {
                return 'In Review'
            } else if (stageVal === 6) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 5) {
            if (stageVal === 2) {
                return StepperName
            } else if (stageVal === 3) {
                return 'To Be Reviewed'
            } else if (stageVal === 4) {
                return 'In Review'
            } else if (stageVal === 5) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 7 && type !== "MPMPA") {
            if (stageVal === 4) {
                return StepperName
            } else if (stageVal === 5) {
                return 'To Be Reviewed'
            } else if (stageVal === 6) {
                return 'In Review'
            } else if (stageVal === 7) {
                return 'Authorized'
            } else {
                return ''
            }
        } else if (totalStages === 4) {
            if (stageVal === 1) {
                return StepperName
            } else if (stageVal === 2) {
                return 'To Be Reviewed'
            } else if (stageVal === 3) {
                return 'In Review'
            } else if (stageVal === 4) {
                return 'Authorized'
            } else {
                return ''
            }
        }
        if (type === "MPMPA") {
            if (stageVal === 3) {
                return StepperName
            } else if (stageVal === 4) {
                return 'To Be Reviewed'
            } else if (stageVal === 5) {
                return 'In Review'
            } else if (stageVal === 7) {
                return 'Authorized'
            } else {
                return ''
            }
        }
    }

    const stepperValue = (stageVal, stageName, totalStages, type) => {
        if (totalStages === 6 || type === 'AFF') {
            if (stageVal === 3) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 5) {
            if (stageVal === 2) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 7 && type === undefined) {
            if (stageVal === 4) {
                return StepperName
            } else {
                return stageName
            }
        } else if (totalStages === 7 && type === "MCDA") {
            if (stageVal === 3) {
                return "Pending Submission"
            } else if (stageVal === 4) {
                return "Pending Review"
            } else if (stageVal === 6) {
                return "Incomplete"
            } else if (stageVal === 5) {
                return "In Review"
            } else if (stageVal === 7) {
                return stageName
            }

        }

    }

    const PreviewRemittance = "View Document"

    const getQuarterAndYear = (date) => {
        const quarterNames = ['Jan 01<sup>st</sup> - Mar 31<sup>st</sup>', "Apr 01<sup>st</sup> - Jun 30<sup>th</sup>", "Jul 01<sup>st</sup> - Sep 30<sup>th</sup>", "Oct 01<sup>st</sup> - Dec 31<sup>st</sup>"]
        const month = date.getMonth()
        let quarter = Math.floor(month / 3) + 1
        let year = date.getFullYear()
        if (quarter === 1) {
            quarter = 4
            year = year - 1
        } else {
            quarter = quarter - 1
        }
        const quarterYear = `Billing Quarter: Q${quarter} - ${year} (${quarterNames[quarter - 1]})`
        return quarterYear
    }

    const BackBtnDisableWod = () => {
        const userData = localStorage.getItem("userData")
        if (userData) {
            const parsedData = JSON.parse(userData)
            const roles = parsedData?.userRoles
            if (Array.isArray(roles)) {
                return roles.some(role => role.rId === 1 || role.rId === 8)
            }
        }
        return false
    }

    const getSortedData = (data, sortConfig) => {
        if (!sortConfig.key) return data

        return [...data].sort((a, b) => {
            let aValue = a[sortConfig.key] || ''
            let bValue = b[sortConfig.key] || ''
            // Special handling for date
            if (sortConfig.key === 'usedDate') {
                aValue = new Date(aValue)
                bValue = new Date(bValue)
                return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
            }

            // Handle strings
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                return sortConfig.direction === 'asc' ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue)
            }

            // Handle numbers
            return sortConfig.direction === 'asc' ? aValue - bValue : bValue - aValue
        })
    }

    const removeFileExtension = (fileName) => {
        const lastDotIndex = fileName.lastIndexOf('.')
        if (lastDotIndex !== -1) {
            return fileName.substring(0, lastDotIndex)
        }
        return fileName
    }

    const ApproverRole = (woId) => {
        const userData = localStorage.getItem("userData")
        if (userData) {
            const parsedData = JSON.parse(userData)
            const roles = parsedData?.userRoles
            if (Array.isArray(roles) && roles.some(role => role.rId === 8 && role.wtId === woId)) {
                return true
            }
        }
        return false
    }

    const getEnvironment = () => {
        const azureAdB2CString = localStorage.getItem('azureAdB2C')
        const azureAdB2C = azureAdB2CString ? JSON.parse(azureAdB2CString) : ''
        const hostname = azureAdB2C ? azureAdB2C.hostname : ''
        let env = ""
        if (hostname === 'https://localhost:44362') {
            env = "-dev"
        } else if (hostname === 'https://seafarer-dev.liscr.com') {
            env = "-dev"
        } else if (hostname === 'https://seafarer-tst.liscr.com') {
            env = "-tst"
        } else if (hostname === 'https://seafarer-stg.liscr.com') {
            env = "-stg"
        }

        return env
    }

    // const no80BroadRule = () => yup.string().nullable().test('no-80-broad', 'Address containing "80 Broad" is not allowed', value => {
    //   if (!value) return true
    //   const restrictedvalue = value.replace(/\s+/g, '').toLowerCase()
    //   return !restrictedvalue.includes('80broad')
    // })

    const no80BroadRuleMsg = 'Address containing "80 Broad" is not allowed'
    const validationPattern = /\b80 broad\b/i
    const no80BroadRule = () => yup.string().nullable().test('no-80-broad', no80BroadRuleMsg, (value) => {
        if (!value) return true
        const normalized = value.toLowerCase()
        const forbiddenPattern = validationPattern
        return !forbiddenPattern.test(normalized)
    })

    const broadRuleType = 'no-80-broad'

    const zoomInOut = { animate: { opacity: 1, scale: 1 }, transition: { duration: 1, delay: 0.1 }, initial: { opacity: 0, scale: 0.5 }, exit: { opacity: 0, scale: 0.5 } }
    const leftToRight = { animate: { x: 0 }, transition: { type: 'slide', stiffness: 120 }, initial: { x: '-100%' }, exit: { x: '100%' } }
    return {
        headerText,
        selectStyles,
        DocusignTitle,
        CreditCardpercentage,
        CreditCardNote,
        PaymentInstructions,
        customCss,
        invalidCss,
        validCss,
        AcknowledgementDocusignTitle1,
        AcknowledgementDocusignTitleRenewal,
        requestByValidationMessage,
        InvoicePaymentModes,
        InvoicePaymentStatus,
        isWithinOneYearRange,
        // formatDate,
        WOStatus,
        DisplayStatus,
        errorresponse,
        authAxios,
        authAxiosMulti,
        sorter,
        SortingDate,
        datesList,
        monthnames,
        DateFormat,
        YearMonthDateFormat,
        validateFilename,
        filterValidFiles,
        statusNamesForStageValues,
        AmountFormat,
        timerLimit,
        StringtoDateMonthYearFormat,
        StampView,
        stepperValue,
        AnonymousPageStatusColor,
        DateTimeConversion,
        ChatDateTimeConversion,
        GetYearAndMonth,
        DateConversion,
        DateEstConversion,
        displayCompanyValue,
        ReplaceString,
        emailDurationTime,
        PreviewLoaTitle,
        timer,
        myEncodeURIComponent,
        myDecodeURIComponent,
        getQuarterAndYear,
        zoomInOut,
        leftToRight,
        isEmployee,
        IsEmployeeCompanyName,
        PreviewRemittance,
        preorderInvoiveTitle,
        productcodeTitle,
        specialCharacterErrorMessage,
        specialCharacterPattern,
        hashCharacterPattern,
        postalCodeMax,
        postalCodeMin,
        postalCodeErrorMessaage,
        authorizeContent,
        GetUserData,
        paymentTypeList,
        getUserRole,
        BackBtnDisableWod,
        ApproverRole,
        getEnvironment,
        agentClassficationList,
        no80BroadRule,
        broadRuleType,
        CrewTypes,
        getSortedData,
        removeFileExtension,
        handlePreviewClick
    }
}
